import { colors } from '@creditornot/cb-ingredients';

const areaColorKeys: (keyof typeof colors)[] = ['lime100', 'orange100', 'wolt100', 'plum100', 'banana100'];

export const getAreaColor = (index: number) => colors[areaColorKeys[index % areaColorKeys.length]];

export const disabledAreaColor = { dark: colors.salt64, light: colors.pepper32, lightHighContrast: colors.pepper32 };
